import { NativeService } from './../../../services/native.service';
import { ContactListComponent } from '../contact-list/contact-list.component';
import { SelectContactSearchComponent } from './select-contact-search.component';
import { ModalController } from '@ionic/angular';
import { ContactResultModel } from 'app/models/dms/contact.model';
import { Component, OnInit, OnChanges, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-select-contact',
    templateUrl: './select-contact.component.html',
    styleUrls: ['./select-contact.component.scss'],
    standalone: false
})
export class SelectContactComponent implements OnInit {
	@Input() id: string;
	@Input() value: string;
	@Input() label: string;
	@Input() selectedValue: string;
	@Input() classes: string;
	@Input() editable: boolean = true;
	@Input() sideload: ContactResultModel;

	@Output() mcChange: EventEmitter<ContactResultModel> = new EventEmitter<ContactResultModel>();

	constructor(public modalController: ModalController,
		protected nativeService: NativeService) {


	}

	ngOnInit() {
	}

	async showModal() {
		if (!this.editable) return;
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");
		const modal = await this.modalController.create({
			component: SelectContactSearchComponent,
			componentProps: {
				'title': '' + this.label,
				'selectedContact': this.selectedValue,
				'selectedContactId': this.value,
				'contactClass': this.sideload.contactClass,
				'contactType': this.sideload.contactType,
				'salesStatus': this.sideload.salesStatus,
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);
		if (data && data.contact) {
			// console.log("Modal dismissed ", data);
			this.setContact(data.contact);
		}
	}

	private setContact(contact: ContactResultModel) {
		this.id = contact.id;
		this.selectedValue = contact.displayName;
		this.mcChange.emit(contact);
	}

	public getSelectedValue() {
		return this.selectedValue ? this.selectedValue : '-';
	}
	public itemHasValue() {
		return this.selectedValue ? true : false;
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}
}
